/**
 * Strip HTML for compact list/search UI (VIO voucher.description is often HTML).
 */
export function htmlToPlainText(html) {
  if (html == null || typeof html !== 'string') return '';
  const trimmed = html.trim();
  if (!trimmed) return '';
  try {
    const doc = new DOMParser().parseFromString(trimmed, 'text/html');
    const text = doc.body?.textContent || '';
    return text.replace(/\s+/g, ' ').trim();
  } catch {
    return trimmed
      .replace(/<[^>]+>/g, ' ')
      .replace(/&nbsp;/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
}
